import React, { useContext, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DashboardController from '../../dashboard/DashboardController'
import ProductsListController from '../../products/productslist/ProductsListController'
import StockInListController from '../../stockin/stockinlist/StockInListController'
import StockOutListController from '../../stockout/stockoutlist/StockOutListController'
import InvoiceListController from '../../invoice/invoicelist/InvoiceListController'
import CustomersAccountsListController from '../../customers_accounts/customers_accounts_list/CustomersAccountsListController'
import ReceiptsListController from '../../receipt/receiptslist/ReceiptsListController'
import SettingsController from '../../settings/SettingsController'
import ReportsController from '../../reports/ReportsController'
import UtilitiesController from '../../utilities/utilities/UtilitiesController'
import HelpController from '../../help/HelpController'

import { appContext } from '../../../App'
import MenuStyle from './css/MenuStyle'

function Menu() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const signed_in = app.client.signed_in
  const componentsList =  {
    dashboard: <DashboardController />,
    products: <ProductsListController />,
    stock_in: <StockInListController />,
    stock_out: <StockOutListController />,
    invoice: <InvoiceListController />,
    customers_accounts: <CustomersAccountsListController />,
    receipt: <ReceiptsListController />,
    reports: <ReportsController />,
    utilities: <UtilitiesController />,
    settings: <SettingsController />,
    help: <HelpController />
  }

  const setActiveMenu = (target) => {
    // Clear the active menu
    const menuButtons = document.querySelectorAll('.menu-list button');
    menuButtons.forEach((button, index) => {
      // Clear class name
      button.classList.remove('active-menu')
    })

    // Set active menu
    target.classList.add('active-menu')
  }

  const showComponent = async (e) => {
    const btn = e.target.closest('.menu-btn')
    setActiveMenu(btn)
    setContent(componentsList[btn.name])
  }

  useEffect(() => {
    // Default the Dashboard apps mount
    const btn = document.getElementById('menu-btn-dashboard')
    setActiveMenu(btn)
    setContent(componentsList[btn.name])
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <React.Fragment>
      <div id='menu'>
        <nav id='nav-bar'>
          <ul className='menu-list'>
            <li id='nav-dashboard' className="nav-item">
              <button onClick={showComponent} name='dashboard' className='menu-btn' id='menu-btn-dashboard'>
                <div className="menu-btn-caption">
                  <div className='btn-icon'>
                    <FontAwesomeIcon icon='tachometer-alt'/>
                  </div>
                  <div className='btn-caption'>
                    Dashboard
                  </div>
                </div>
                <div className="arrow"></div>
              </button>
            </li>
            <li id='nav-products' className="nav-item">
              <button onClick={showComponent} name='products' className="menu-btn" id="menu-btn-products">
                <div className="menu-btn-caption">
                  <div className='btn-icon'>
                    <FontAwesomeIcon icon='box-open'/>
                  </div>
                  <div className='btn-caption'>
                    Products
                  </div>
                </div>
                <div className="arrow" id="products-arrow"></div>
              </button>
            </li>
            <li id='nav-stockin' className="nav-item">
              <button onClick={showComponent} name='stock_in' className="menu-btn" id="menu-btn-stock-in">
                <div className="menu-btn-caption">
                  <div className='btn-icon'>
                    <FontAwesomeIcon icon='boxes'/>
                  </div>
                  <div className='btn-caption'>
                    Stockin
                  </div>
                </div>
                <div className="arrow"></div>
              </button>
            </li>
            <li id='nav-stockout' className="nav-item">
              <button onClick={showComponent} name='stock_out' className="menu-btn" id="menu-btn-stock-out">
                <div className="menu-btn-caption">
                  <div className='btn-icon'>
                    <FontAwesomeIcon icon='dolly-flatbed'/>
                  </div>
                  <div className='btn-caption'>
                    Stockout
                  </div>
                </div>
                <div className="arrow"></div>
              </button>
            </li>
            <li id='nav-invoice' className="nav-item">
              <button onClick={showComponent} name='invoice' className="menu-btn" id="menu-btn-invoice">
                <div className="menu-btn-caption">
                  <div className='btn-icon'>
                    <FontAwesomeIcon icon='paperclip'/>
                  </div>
                  <div className='btn-caption'>
                    Invoice
                  </div>
                </div>
                <div className="arrow"></div>
              </button>
            </li>
            <li id='nav-customers_accounts' className="nav-item">
              <button onClick={showComponent} name='customers_accounts' className="menu-btn" id="menu-btn-customers-accounts">
                <div className="menu-btn-caption">
                  <div className='btn-icon'>
                    <FontAwesomeIcon icon='user'/>
                  </div>
                  <div className='btn-caption'>
                    Customers Accounts
                  </div>
                </div>
                <div className="arrow"></div>
              </button>
            </li>
            <li id='nav-receipts' className="nav-item">
              <button onClick={showComponent} name='receipt' className="menu-btn" id="menu-btn-receipt">
                <div className="menu-btn-caption">
                  <div className='btn-icon'>
                    <FontAwesomeIcon icon='receipt'/>
                  </div>
                  <div className='btn-caption'>
                    Receipts
                  </div>
                </div>
                <div className="arrow"></div>
              </button>
            </li>
            <li id='nav-reports' className="nav-item">
              <button onClick={showComponent} name='reports' className="menu-btn" id="menu-btn-reports">
                <div className="menu-btn-caption">
                  <div className='btn-icon'>
                    <FontAwesomeIcon icon='chart-line'/>
                  </div>
                  <div className='btn-caption'>
                    Reports
                  </div>
                </div>
                <div className="arrow"></div>
              </button>
            </li>
            <li id='nav-utilities' className="nav-item">
              <button onClick={showComponent} name='utilities' className="menu-btn" id="menu-btn-utilities">
                <div className="menu-btn-caption">
                  <div className='btn-icon'>
                    <FontAwesomeIcon icon='tools'/>
                  </div>
                  <div className='btn-caption'>
                    Utilities
                  </div>
                </div>
                <div className="arrow"></div>
              </button>
            </li>
            <li id='nav-settings' className="nav-item">
              <button onClick={showComponent} name='settings' className="menu-btn" id="menu-btn-settings">
                <div className="menu-btn-caption">
                  <div className='btn-icon'>
                    <FontAwesomeIcon icon='cogs'/>
                  </div>
                  <div className='btn-caption'>
                    Settings
                  </div>
                </div>
                <div className="arrow"></div>
              </button>
            </li>
            <li id='nav-help' className="nav-item">
              <button onClick={showComponent} name='help' className="menu-btn" id="menu-btn-help">
                <div className="menu-btn-caption">
                  <div className='btn-icon'>
                    <FontAwesomeIcon icon='people-carry'/>
                  </div>
                  <div className='btn-caption'>
                    Help
                  </div>
                </div>
                <div className="arrow"></div>
              </button>
            </li>
          </ul>
        </nav>
      </div>
      <MenuStyle signed_in={signed_in}/>
    </React.Fragment>
  )
}

export default React.memo(Menu);
